module.exports = __webpack_public_path__ + "static/img/test.18e45ab5.jpg";